/** Docs app URL for cross-app links (see NEXT_PUBLIC_WEB_DOCS_URL). */
export function getDocsExternalUrl(): string {
  const raw = process.env.NEXT_PUBLIC_WEB_DOCS_URL?.trim()

  if (!raw || raw.startsWith('BAKED_')) {
    return ''
  }

  return raw.replace(/\/$/, '')
}
